import { CollateralItemCharTypes } from '@/types';

export const COLLATERAL_ITEM_CHARS = [
  { label: 'Число', value: CollateralItemCharTypes.NUMERIC, defaultValue: 0 },
  { label: 'Строка', value: CollateralItemCharTypes.STRING, defaultValue: '' },
  { label: 'Пометка', value: CollateralItemCharTypes.BOOLEAN, defaultValue: false },
];
